interface CompressorHighlightState {
  highlightedStage: number | undefined;
  energyAIFallbackStage: number | undefined;
}

export const getCompressorHighlightState = ({
  activeStage,
  cosmicActive,
  cosmicFallbackStage,
}: {
  activeStage: unknown;
  cosmicActive: boolean | undefined;
  cosmicFallbackStage: number | undefined;
}): CompressorHighlightState => {
  return {
    highlightedStage:
      cosmicActive === true ? undefined : typeof activeStage === 'number' ? activeStage : undefined,
    energyAIFallbackStage: cosmicActive === true ? cosmicFallbackStage : undefined,
  };
};
